export default __webpack_public_path__ + "static/media/DSC02147.6480cb4c.jpg";